import React, { Component, Fragment } from 'react';
import PropertyTable from './PropertyTable';
import { Button, Header, Icon, Segment, SegmentGroup } from 'semantic-ui-react';
import {
    checkFaculty,
    checkOrganizationalUnitsPrivilege,
    checkWritePrivilege, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
    formatListForDropdownOptions,
    getTotalNumberOfPages
} from '../util/util';
import axios from 'axios';
import { fetchOrganizationalUnits } from '../Lookups/util';
import { toast, ToastContainer } from 'react-toastify';
import PropertyList from './PropertyList';
import PropertyDetails from './PropertyDetails';
import EditProperty from './Details/EditProperty';
import { Redirect } from 'react-router-dom';
import NewProperty from './NewProperty';
import { FiltersOnStyle, IconHeader } from '../util/css';
import PaginationSegment from '../util/PaginationSegment';
import { FACULTY_ADMIN, fetchActiveRole, fetchUserOrganizationalUnit } from '../util/roles';
import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader';

class ActiveProperty extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: true,

            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
            organizationalUnitProperties: [],
            allOrganizationalUnitProperties: []
        };
        this.fetchAllOrganizationalUnitProperties = this.fetchAllOrganizationalUnitProperties.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.activateDetailsRequest = this.activateDetailsRequest.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getOrganizationalUnitProperties = this.getOrganizationalUnitProperties.bind(this);
        this.updateOrganizationalUnitProperties = this.updateOrganizationalUnitProperties.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.fetchOrganizationalUnitProperties = this.fetchOrganizationalUnitProperties.bind(this);
        this.getWritePrivilege = this.getWritePrivilege.bind(this);
    }
    componentDidMount() {
        localStorage.removeItem('ouId');
        localStorage.removeItem('property');
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchOrganizationalUnitProperties(0, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, organizationalUnitId);
                } else {
                    this.fetchAllOrganizationalUnitProperties();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }


    fetchOrganizationalUnitProperties(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, organizationalUnitId) {
        const pagination = {
            page,
            resultsPerPage,
        };
        axios.post('/assets/organizational-unit-properties/paginated/', { ...pagination }).then((res) => {
            const allOrganizationalUnitProperties = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ organizationalUnitProperties: allOrganizationalUnitProperties, totalPages, loading: false });
            this.updateOrganizationalUnitProperties(page, resultsPerPage, res);
        });
    }
    fetchAllOrganizationalUnitProperties(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        this.setState({ loading: true });
        axios.post('/assets/organizational-unit-properties/all/', { ...pagination }).then((res) => {
            const allOrganizationalUnitProperties = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ organizationalUnitProperties: allOrganizationalUnitProperties, totalPages, loading: false });
        });
    }
    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredOrganizationalUnitProperties(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchOrganizationalUnitProperties(activePage - 1, this.state.resultsPerPage);
        }
    }
    getOrganizationalUnitProperties(page, resultsPerPage) {
        const {
            activeRole, fieldName, fieldProperty, direction
        } = this.state;
        const pagination = {
            page,
            resultsPerPage,

        };


        axios.post('/assets/organizational-unit-properties/all/', { ...pagination })
            .then(res => {
                this.updateOrganizationalUnitProperties(page, resultsPerPage, res);
            })
            .catch(err => {
                toast('Došlo je do greške!');
                console.log('Greska!');
            });
    }

    updateOrganizationalUnitProperties(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages,
        }));
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filteredOrganizationalUnitProperties;
        }
        return this.state.organizationalUnitProperties.reverse();
    }

    activateEditRequest() {
        this.setState({ activateEditRequest: true });
    }

    activateDetailsRequest() {
        this.setState({ activateDetailsRequest: true });
    }

    getWritePrivilege() {
        const activeRole = localStorage.getItem('activeRole');
        if (activeRole === FACULTY_ADMIN || activeRole.substr(0, 18) === FACULTY_ADMIN) {
            return true;
        }
        return false;
    }


    render() {
        const {
            openNewProperty,
        } = this.state;
        if (this.state.activateEditRequest) {
            return <Redirect push to={{ pathname: '/imovina/nepokretna-imovina/izmjena' }} />;
        }
        if (this.state.activateDetailsRequest) {
            return <Redirect push to={{ pathname: '/imovina/nepokretna-imovina/detalji' }} />;
        }
        const writePrivilege = this.getWritePrivilege();
        return (
            // eslint-disable-next-line react/jsx-no-undef
            <div>
                <Header as="h1">Nepokretna imovina</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak nepokretne imovine
                            <Header style={IconHeader} floated="right">
                                {writePrivilege &&
                                <Button
                                    color="blue"
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({ openNewProperty: true })}
                                ><Icon className="add" />
                                Dodavanje imovine
                                </Button>}
                            </Header>

                        </Header>
                    </Segment>
                    <Segment>
                        {openNewProperty && <NewProperty
                            fetchOrganizationalUnitProperties={this.fetchOrganizationalUnitProperties}
                            organizationalUnitId={this.state.organizationalUnitId}
                            closeForm={() => this.setState({ openNewProperty: false })}
                        />}
                        {
                            this.state.loading ?
                                <div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div> :
                                (this.state.organizationalUnitProperties && this.state.organizationalUnitProperties.length !== 0) ?
                                    <Fragment>
                                        <PropertyList
                                            allOrganizationalUnitProperties={this.state.organizationalUnitProperties}
                                            activateEditRequest={this.activateEditRequest}
                                            activateDetailsRequest={this.activateDetailsRequest}
                                        />
                                        <PaginationSegment
                                            activePage={this.state.activePage}
                                            totalPages={this.state.totalPages}
                                            onPageChange={this.handlePageChange}
                                        />
                                    </Fragment>
                                    :
                                    'Nema podataka o imovini.'
                        }

                    </Segment>
                    <ToastContainer hideProgressBar />
                </SegmentGroup>


            </div>
        );
    }
}

export default ActiveProperty;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/ActiveProperty.js